function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The TextArea component provides a text area with total character count
 * indicator
 *
 * - [MDN docs for textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
 *
 * ## Related Components
 * - [TextInput](../TextInput/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <TextArea
 *   variant="underline"
 *   name="myField"
 *   placeholder="Type something"
 *   minLength={0}
 *   maxLength={140}
 *   rows={2}
 *   onChange={({ target: { value } }) => console.log('value', value)}
 * />
 *```
 *
 * ## Props
 */

var TextArea = /*#__PURE__*/function (_AbstractInput) {
  _inherits(TextArea, _AbstractInput);

  var _super = _createSuper(TextArea);

  function TextArea() {
    _classCallCheck(this, TextArea);

    return _super.apply(this, arguments);
  }

  _createClass(TextArea, [{
    key: "render",
    value: function render() {
      var isFocused = this.state.isFocused;
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          variant = _this$props.variant,
          name = _this$props.name,
          form = _this$props.form,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          minLength = _this$props.minLength,
          rows = _this$props.rows,
          onChange = _this$props.onChange;

      var _TextArea$getClassNam = TextArea.getClassName({
        variant: variant,
        className: className,
        disabled: disabled,
        isFocused: isFocused
      }),
          root = _TextArea$getClassNam.root,
          control = _TextArea$getClassNam.control,
          countClass = _TextArea$getClassNam.count;

      var controlId = id || this.id;
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: controlId,
        className: root
      }, /*#__PURE__*/React.createElement("textarea", {
        id: controlId,
        className: control,
        name: name,
        value: value,
        form: form,
        disabled: disabled,
        readOnly: readOnly,
        rows: rows,
        required: required,
        onChange: onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        placeholder: placeholder,
        maxLength: maxLength,
        minLength: minLength
      }), maxLength && /*#__PURE__*/React.createElement("div", {
        className: countClass
      }, "".concat(value.length, "/").concat(maxLength)));
    }
  }]);

  return TextArea;
}(AbstractInput);

TextArea.defaultProps = {
  id: '',
  className: '',
  variant: '',
  name: '',
  form: '',
  disabled: false,
  readOnly: false,
  required: false,
  placeholder: '',
  maxLength: 512,
  minLength: 0,
  rows: 3,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  value: ''
};
TextArea.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Presentational variants
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['underline']), PropTypes.string]),

  /**
   * The unique id for the control
   */
  id: PropTypes.string,

  /**
   * The name associated with the controls value.
   */
  name: PropTypes.string,

  /**
   * The value to be chosen
   */
  value: PropTypes.string,

  /**
   * id of associated form element
   */
  form: PropTypes.string,

  /**
   * Whether the user is able to type into the text area
   */
  disabled: PropTypes.bool,

  /**
   * Whether the text area is read only or not
   */
  readOnly: PropTypes.bool,

  /**
   * Marks the text area as required
   */
  required: PropTypes.bool,

  /**
   * Placeholder text for the control
   */
  placeholder: PropTypes.string,

  /**
   * Maximum number of characters for the control
   */
  maxLength: PropTypes.number,

  /**
   * The minimum number of character for the control
   */
  minLength: PropTypes.number,

  /**
   * Number of visible rows of text
   */
  rows: PropTypes.number,

  /**
   * event callback to be called when text is enter
   */
  onChange: PropTypes.func,

  /**
   * event callback to be called when text is enter
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when text is enter
   */
  onBlur: PropTypes.func
};

TextArea.getClassName = function (_ref) {
  var variant = _ref.variant,
      className = _ref.className,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled;
  return {
    root: cx('psw-text-area', _defineProperty({}, "psw-text-area-".concat(variant), !!variant), {
      'psw-is-disabled': disabled
    }, {
      'psw-is-focused': isFocused
    }, className),
    control: cx('psw-shadow-s', 'psw-p-s', 'psw-fill-x', {
      'psw-underlined': variant === 'underline'
    }),
    count: cx('psw-text-area-count', 'psw-p-t-s', 'psw-l-line-right')
  };
};

TextArea.useClassNames = function (classNames) {
  TextArea.classNames = classNames;
};

cx = classNamesFor(TextArea);
export default TextArea;